/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import { getRoomRatios } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import {
	Avatar,
	CircularProgress,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@material-ui/core';
import Pusher from 'pusher-js';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './Reports.css';

export default function RoomCheck() {
	const dispatch = useDispatch();
	const [rows, setRows] = useState([]);
	const [isLoading, setLoading] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const enrolledStudentRef = useRef(null);
	const [rooms, setRooms] = useState([]);
	const [roomPage, setRoomPage] = useState(1);
	const [totalRooms, setTotalRooms] = useState([]);
	const [hasMore, setHasMore] = useState(false);
	const [page, setPage] = useState(1);
	const [fetchingMore, setFetchingMore] = useState(false);
	const navigate = useNavigate();
	const user = useSelector(({ auth }) => auth.user);

	// useEffect(() => {
	// 	setFetchingMore(true);
	// 	getRoomRatios(1)
	// 		.then(({ data }) => {
	// 			setTotalRooms(data.data);
	// 			if (data.current_page < data.last_page) {
	// 				setHasMore(true);
	// 				setPage(data.current_page + 1);

	// 			} else {
	// 				setHasMore(false);
	// 			}
	// 			console.log(data)
	// 		})
	// 		.catch(err => {
	// 			if (err.response?.data?.message) {
	// 				dispatch(
	// 					Actions.showMessage({
	// 						message: err?.response?.data?.message,
	// 						autoHideDuration: 2500,
	// 						variant: 'error'
	// 					})
	// 				);
	// 			} else {
	// 				dispatch(
	// 					Actions.showMessage({
	// 						message: 'Failed to load schools',
	// 						autoHideDuration: 2500,
	// 						variant: 'error'
	// 					})
	// 				);
	// 			}
	// 		})
	// 		.finally(() => {
	// 			setFetchingMore(false);
	// 		});
	// }, []);

	useEffect(() => {
		let isMounted = true;
		setFetchingMore(true);
		getRoomRatios(1)
			.then(({ data }) => {
				if (!isMounted) return;
				setTotalRooms(data.data);
				if (data.current_page < data.last_page) {
					setHasMore(true);
					setPage(data.current_page + 1);
				} else {
					setHasMore(false);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				if (err.response?.data?.message) {
					dispatch(
						Actions.showMessage({
							message: err?.response?.data?.message,
							autoHideDuration: 2500,
							variant: 'error',
						})
					);
				} else {
					dispatch(
						Actions.showMessage({
							message: 'Failed to load schools',
							autoHideDuration: 2500,
							variant: 'error',
						})
					);
				}
			})
			.finally(() => {
				if (!isMounted) return;
				setFetchingMore(false);
			});

		const pusher = new Pusher(import.meta.env.VITE_PUSHER_CHANNEL_ID, {
			cluster: import.meta.env.VITE_PUSHER_CLUSTER_ID,
		});
		const channel = pusher.subscribe(
			`ld-channel-${
				user.role[0] === 'school_admin' || user.role[0] === 'sub_admin' ? user.data.school.id : user.school?.id
			}`
		);
		channel.bind('ld-room-ratio-update-event', () => {
			getRoomRatios(1)
				.then(({ data }) => {
					if (!isMounted) return;
					setTotalRooms(data.data);
					if (data.current_page < data.last_page) {
						setHasMore(true);
						setPage(data.current_page + 1);
					} else {
						setHasMore(false);
					}
				})
				.catch((err) => {
					if (!isMounted) return;
					if (err.response?.data?.message) {
						dispatch(
							Actions.showMessage({
								message: err?.response?.data?.message,
								autoHideDuration: 2500,
								variant: 'error',
							})
						);
					} else {
						dispatch(
							Actions.showMessage({
								message: 'Failed to load schools',
								autoHideDuration: 2500,
								variant: 'error',
							})
						);
					}
				});
		});
		return () => {
			isMounted = false;
			pusher.disconnect();
		};
	}, []);

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="mx-auto enrolled-cont">
				<div className="flex items-center justify-between">
					<div className="reports-topDiv">
						<h1 className="my-16">
							<span className="">
								<IconButton
									onClick={() => {
										navigate(-1);
									}}
								>
									<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>
							<span className="text-pd-xl self-end font-bold mr-28">Room Check</span>
						</h1>
						<p>Check the real time students staff ratios of classroom</p>
					</div>
				</div>

				{/* table  */}
				<TableContainer className="student-table-cont" component={Paper} id="Scrollable-table">
					<Table className="enrolledtudent-table" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
									Room
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
									Student In
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
									Staff In
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
									Ratio
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className="">
							{isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows.length && !firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No Room Check
									</TableCell>
								</TableRow>
							) : (
								totalRooms?.map((row) => (
									<TableRow key={row.id}>
										<TableCell>
											<div className="flex items-center">
												<Avatar src={row?.thumb} />
												<div className="flex ">
													<span className="m-4 check-name truncate" style={{ width: '135px' }}>
														{row?.name}
													</span>
												</div>
											</div>
										</TableCell>
										<TableCell>
											<span className="rows-ration-student check-name">{row?.checkins_room_count}</span>
										</TableCell>
										<TableCell>
											<span className="check-name">{row.staff_checkins?.length}</span>
										</TableCell>
										<TableCell>
											<span className="check-name">
												{row?.checkins_room_count}&nbsp;:&nbsp;{row.staff_checkins?.length}
											</span>
										</TableCell>
									</TableRow>
								))
							)}
							{fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : (
								<></>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</div>
		</FuseAnimate>
	);
}
